import logo from "./logo.svg";
import "./App.scss";
import { Route, Routes } from "react-router-dom";
import Login from "./Pages/Login";
import UserRegistration from "./Pages/UserRegistration";
import ProtectedRoute from "./Security/ProtectedRoute";
import UserLayout from "./Components/UserLayout";
import UserDashboard from "./Pages/UserDashboard";
import UserProfile from "./Pages/UserProfile";
import { useEffect } from "react";
import { LocalStorageService } from "./services/LocalStorage";
import { isLogin, setUserData } from "./Actions";
import AxiosService from "./services/APIService";
import { connect } from "react-redux";
import UserFiles from "./Pages/UserFiles";
import FAQS from "./Pages/FAQS";
import Notes from "./Pages/Notes";
import PaymentQr from "./Pages/PaymentQr";
import ThankYouPage from "./Pages/ThankYouPage";
import ResetPassword from "./Pages/ResetPassword";
import Promocode from "./Pages/Promocode";
import Commission from "./Pages/Commission";
import InquieryForm from "./Pages/InquieryForm";
import PaymentSuccess from "./Pages/PaymentSuccess";
import PaymentCancel from "./Pages/PaymentCancel";
import MyPurchase from "./Pages/MyPurchase";

function App({ isLogin }) {
  const apiService = new AxiosService();
  useEffect(() => {
    const token = LocalStorageService.getItem("userToken");
    // document.title = 'AIFXBRAIN V1.0';
    if (token) {
      checkAuthentication();
    } else {
      isLogin(false);
      setUserData(null);
    }
  }, []);

  const checkAuthentication = async () => {
    apiService
      .get("/auth/me")
      .then((res) => {
        isLogin(true);
        setUserData(res?.user);
      })
      .catch(() => {
        isLogin(false);
        setUserData(null);
        LocalStorageService.removeItem("userToken");
      });
  };

  return (
    <>
      <Routes>
        <Route path="/" Component={Login} />
        <Route path="/registration" Component={UserRegistration} />
        <Route path="/payment-QR" Component={PaymentQr} />
        <Route path="/thank-you" Component={ThankYouPage} />
        <Route path="/pip-grid/inquiry" Component={InquieryForm} />
        <Route path="/reset-password/:token" Component={ResetPassword} />
        <Route path="/payment/cancel" Component={PaymentCancel} />
        <Route path="/payment/success" Component={PaymentSuccess} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute layout={UserLayout} component={UserDashboard} />
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute layout={UserLayout} component={UserProfile} />
          }
        />
        <Route
          path="/files"
          element={<ProtectedRoute layout={UserLayout} component={UserFiles} />}
        />
        <Route
          path="/faqs"
          element={<ProtectedRoute layout={UserLayout} component={FAQS} />}
        />
        <Route
          path="/notes"
          element={<ProtectedRoute layout={UserLayout} component={Notes} />}
        />
        <Route
          path="/promocode"
          element={<ProtectedRoute layout={UserLayout} component={Promocode} />}
        />
        <Route
          path="/commission"
          element={
            <ProtectedRoute layout={UserLayout} component={Commission} />
          }
        />
        <Route
          path="/my-purchase"
          element={
            <ProtectedRoute layout={UserLayout} component={MyPurchase} />
          }
        />
      </Routes>
    </>
  );
}

const mapStateToProps = ({ login }) => {
  const { user } = login;
  return { user };
};

const mapDispatchToProps = {
  isLogin,
  setUserData,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
